export const stats = {
  page_heading: "Usage Statistics",
  page_head_template: "%s - Statistics - %s",
  page_head_noname_template: "Statistics - %s",

  summary_head: "Summary",
  summary_desc: "Overall statistics",

  total_requests: "Total Requests",
  matched_devices: "Matched Devices",
  forward_download: "Forward Download",
  forward_fallback: "Forward Fallback",
  forward_redirect_stats_disabled: "Upgrade plan to enable Redirect stats",

  date_range: "Select Period",
  date_range_desc: "Select period to explore",

  button_device: "Device",
  button_redirect: "Redirects",
  button_country: "Countries",
  button_referrer: "Referrer",
  button_utm: "UTM Tracking",

  heading_device: "Device making request",
  heading_redirect: "Result of request",
  heading_country: "Origin of request",
  heading_referrer: "Referring website",
  heading_utm: "UTM based campaign tracking",

  button_utm_source: "Source",
  button_utm_medium: "Medium",
  button_utm_campaign: "Campaign",
  button_utm_term: "Term",
  button_utm_content: "Content",

  filter_utm_source: "Source:",
  filter_utm_medium: "Medium:",
  filter_utm_campaign: "Campaign:",
  filter_utm_term: "Term:",
  filter_utm_content: "Content:",

  click_to_add_filter: "Click to add filter",
  click_value_to_add_filter: "Click value to add filter",

  device_android: "Android",
  device_huawei: "Huawei",
  device_ios: "iOS*",
  device_iphone: "iPhone",
  device_ipad: "iPad",
  device_windows: "Windows",
  device_blackberry: "BlackBerry*",
  device_kindle: "Kindle",
  device_other: "Other",
  device_total: "Total",

  redirect_android: "Android",
  redirect_huawei: "Huawei",
  redirect_ios: "iOS*",
  redirect_iphone: "iPhone",
  redirect_ipad: "iPad",
  redirect_windows: "Windows",
  redirect_blackberry: "BlackBerry*",
  redirect_kindle: "Kindle",
  redirect_other: "Other",
  redirect_total: "Total",
  redirect_fallback: "Fallback",
  redirect_none: "No redirect",

  sum_total: "Total",
  sum_android: "Android",
  sum_huawei: "Huawei",
  sum_iphone: "iPhone",
  sum_ipad: "iPad",
  sum_ios: "iOS*",
  sum_windows: "Windows",
  sum_blackberry: "Blackberry",
  sum_kindle: "Kindle",
  sum_other: "Other",
  sum_fallback: "Fallback",
  sum_none: "No redirect",

  download_csv: "Download as CSV",
  no_stats: "No statistics recorded for selected period",

  show_chart: "Show Chart",
  hide_chart: "Hide Chart",

  not_included: "This statistics type is not included in your current plan.",
};
